/* eslint-disable react/jsx-props-no-spreading */
import { CircularProgress, IconButton, makeStyles } from "@material-ui/core";
import { Delete, Person } from "@material-ui/icons";
import PropTypes, { oneOfType } from "prop-types";
import React from "react";
import Dropzone from "react-dropzone";

const useStyles = makeStyles(theme => ({
  dropZone: {
    position: "relative",
    outline: "none",
    display: "inline-block",
    width: "160px",
    height: "160px",
    border: "solid 1px",
    borderColor: theme.palette.primary.main,
    cursor: "pointer",
    "&:hover": {
      borderColor: "#63aec7"
    },
    borderRadius: "80px"
  },
  imageRoot: {
    overflow: "hidden",
    position: "relative",
    outline: "none",
    display: "inline-block",
    border: "solid 1px",
    borderColor: theme.palette.primary.main,
    cursor: "pointer",
    height: "160px",
    width: "160px",
    borderRadius: "80px"
  },
  imageIcon: {
    opacity: 0.5,
    display: "block",
    position: "absolute",
    top: "calc(50% - 0.7rem)",
    left: "calc(50% - 0.7rem)",
    color: theme.palette.primary.main
  },
  trashButton: {
    opacity: 0,
    display: "block",
    position: "absolute",
    top: "calc(50% - 1.8rem)",
    left: "calc(50% - 1.8rem)",
    "&:hover": {
      opacity: 1,
      background: theme.palette.primary.secondary
    }
  },
  trashIcon: {
    fontSize: "2rem",
    color: "#B80011"
  },
  loader: {
    position: "absolute",
    top: "calc(50% - 40px)",
    left: "calc(50% - 40px)"
  }
}));

const ImageUploader = ({ imageUrl, imageAlt, loading, onFileUpload, icon: Icon }) => {
  const classes = useStyles();

  if (loading) {
    return (
      <div className={classes.imageRoot}>
        <CircularProgress size={80} className={classes.loader} />
      </div>
    );
  }
  if (imageUrl) {
    const imageSrc = typeof imageUrl === "string" ? imageUrl : URL.createObjectURL(imageUrl);
    return (
      <div className={classes.imageRoot}>
        <img alt={imageAlt} height={160} width={160} src={imageSrc} />

        <IconButton
          aria-label="delete"
          className={classes.trashButton}
          onClick={() => {
            onFileUpload({ file: null });
          }}
        >
          <Delete className={classes.trashIcon} />
        </IconButton>
      </div>
    );
  }

  return (
    <Dropzone
      accept="image/*"
      maxSize={1000000}
      multiple={false}
      onDrop={acceptedFiles => {
        onFileUpload({ file: acceptedFiles[0] });
      }}
    >
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps({ className: classes.dropZone })}>
          <Icon className={classes.imageIcon} />
          <input data-testid="dropzone" {...getInputProps()} />
        </div>
      )}
    </Dropzone>
  );
};

ImageUploader.propTypes = {
  imageUrl: oneOfType([PropTypes.string, PropTypes.object]),
  imageAlt: PropTypes.string,
  onFileUpload: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  icon: PropTypes.elementType
};

ImageUploader.defaultProps = {
  imageUrl: null,
  imageAlt: "",
  loading: false,
  icon: Person
};

export default ImageUploader;
